module.exports = __webpack_public_path__ + "5d2404a6c56f5517ca2a1c77f4cddf32.woff";